import { AppConfigService } from '../shared/providers/config.service';
import { FranchiseAppGlobal } from '../franchise-app-global';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { saveAs } from 'file-saver';

@Injectable()
export class AttachmentService {
    private env;
    constructor(
        public http: HttpClient,
        private config: AppConfigService
    ) {
        this.env = this.config.getConfig();
    }

    // Download File
    DownloadFile(publicId: string, fileName: string) {
        let url = this.env.baseUrl + FranchiseAppGlobal.displayUploadedFileUrl + publicId;
        this.http.get(url, { responseType: 'blob' }).subscribe(
            blob => {
                saveAs(blob, fileName /*, { type: 'text/plain;charset=windows-1252' }*/);
            },
            error => { }
        )
    }
    DownloadAdminFile(publicId: string, fileName: string) {
        let url = this.env.baseUrl + FranchiseAppGlobal.displayAdminUploadedFileUrl + publicId;
        this.http.get(url, { responseType: 'blob' }).subscribe(
            blob => {
                saveAs(blob, fileName /*, { type: 'text/plain;charset=windows-1252' }*/);
            },
            error => { }
        )
    }
}
